import axios from '@/lib/axios';
import { QuotationTask, SalesOrder } from '@/hooks/api/models';
import { useMutation } from '@tanstack/react-query';

/**
 * 1484. 見積タスクアーカイブ解除
 * [PUT] /workspaces/:identifier/teams/:team_id/sales_orders/:sales_order_id/quotation_tasks/:id/unarchive
 */
type Props = {
  identifier: string;
  team_id: number;
  sales_order_id: number;
  id: number;
};
const unarchiveQuotationTask = (props: Props): Promise<QuotationTask> => {
  return axios.put(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/sales_orders/${props.sales_order_id}/quotation_tasks/${props.id}/unarchive`,
    props
  );
};

export const useUnarchiveQuotationTask = () => {
  return useMutation({
    mutationFn: unarchiveQuotationTask,
  });
};
